﻿import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { EntityResponse } from "../models";
import { axiosInstance, validateUuid } from "../../utils";

export function useClientEntities(clientId: string) {
    const axios = axiosInstance();

    return useQuery({
        ...queryKeys.clients.entities(clientId),
        queryFn: () => axios.get<EntityResponse[]>(`api/Clients/${validateUuid(clientId)}/entities`).then(response => response.data),
    });
}
